export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5614.27d5bff7.jpg";